export type HeaderNavLinkItem = { path: string; label: string };

/** Matches `useLanguage().t` shape for nav labels only. */
export type HeaderNavTranslate = (key: string) => string | undefined;

export function buildHeaderNavLinks(t: HeaderNavTranslate): HeaderNavLinkItem[] {
  return [
    { path: '/', label: t('navigation.home') || 'Home' },
    { path: '/webdesigned/stays', label: t('navigation.stays') || 'Stays' },
    { path: '/webdesigned/activities', label: t('navigation.activities') || 'Activities' },
    { path: '/webdesigned/forfaits', label: t('navigation.forfaits') || 'Forfaits' },
    { path: '/webdesigned/gallery', label: t('navigation.gallery') || 'Gallery' },
  ];
}

export function isHeaderNavLinkActive(pathname: string, path: string): boolean {
  if (path === '/' || path === '/webdesigned') {
    return pathname === '/' || pathname === '/webdesigned' || pathname === '/webdesigned/';
  }
  return pathname === path || pathname.startsWith(`${path}/`);
}
